import { Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const WithdrawFallback = () => {
    return (
        <HeaderFallback title="تسویه حساب">
            <Skeleton variant="rectangular" height="550px" />
            <Skeleton variant="rectangular" height="200px" sx={{ mt: 2 }} />
        </HeaderFallback>
    );
};

export default WithdrawFallback;
